import type { NextConfig } from "next";

const nextConfig: NextConfig = {
    images: {
        remotePatterns: [
            { protocol: "https", hostname: "tse2.mm.bing.net" },
            { protocol: "https", hostname: "via.placeholder.com" },
            { protocol: "https", hostname: "sanpham.starglobal3d.com" },
            { protocol: "https", hostname: "sanpham.starglobal3d.vn" },
            { protocol: "https", hostname: "upload.wikimedia.org" },
            { protocol: "https", hostname: "s3.hcm-1.cloud.cmctelecom.vn" },
            { protocol: "https", hostname: "platform.starglobal3d.com" },
        ],
        minimumCacheTTL: 3600,
        formats: ["image/avif", "image/webp"],
        // unoptimized: true,
    },
    output: "standalone",
    basePath: process.env.NEXT_PUBLIC_BASE_PATH_STATIC || "",
    assetPrefix: process.env.NEXT_PUBLIC_BASE_PATH_STATIC || "",
    trailingSlash: true,
    // distDir: 'out',
    webpack: (config, { isServer }) => {
        return config;
    },
};

export default nextConfig;
